import Enum from "../../../../../../enums/Enum";

const BirthTypeEnum = new Enum({
    VAGINAL_BIRTH: {name: "Vaginal Birth"},
    CESAREAN_DELIVERY: {name: "Cesarean Delivery"},
    OTHER: {name: "Other"}
});

export default BirthTypeEnum;